import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings
import WreathsGreensRopingCenterpiecesGallery from "./WreathsGreensRopingCenterpiecesGallery";

class WreathsGreensRopingCenterpieces extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wreathsGreensRopingCenterpiecespage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "wreathsGreensRopingCenterpieces",
    }).then((entries) => {
      this.setState({ wreathsGreensRopingCenterpiecespage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(wreathsGreensRopingCenterpiecesDescription) {
    return {
      __html: marked(wreathsGreensRopingCenterpiecesDescription, { sanitize: false }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <>
      <div className="container-fluid">
        {this.state.wreathsGreensRopingCenterpiecespage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.wreathsGreensRopingCenterpiecespage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-2">
                    <h1 className="text-uppercase">{item.fields.wreathsGreensRopingCenterpiecesTitle}</h1>
                    {/* <h2 className="lead">{item.fields.wreathsGreensRopingCenterpiecesShortDetails}</h2> */}
                  </div>

                  <div className="pt-2">
                    <div className="row">
                      {/* <div className="col-lg-4">
                        <img
                          className="img-fluid"
                          src={item.fields.wreathsGreensRopingCenterpiecesImg.fields.file.url}
                          alt="icon"
                        />
                        
                      </div> */}
                      <div className="col-lg-8">
                        {/* <p>{item.fields.aboutDescription}</p> */}
                        <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.wreathsGreensRopingCenterpiecesDescription
                        )}></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="pt-4">
      <WreathsGreensRopingCenterpiecesGallery/>
      </div>
      </>
    );
  }
}

export default WreathsGreensRopingCenterpieces;
